import {
  gamelabLogo,
  colegioMedicoLogo,
  leanboLogo,
  cloudServer,
  cloudDatabase,
  visualize,
  bukLogo,
  pipedriveLogo,
  talanaLogo,
  talanaDark,
  siiLogo,
  transbankLogo,
  excelLogo,
  tableauLogo,
  powerBILogo,
  hubspotLogo,
  bsaleLogo,
  asanaLogo,
  trelloLogo,
  gadsLogo,
  facebookadsLogo,
  bancoitauLogo,
  bancoestadoLogo,
  bancobciLogo,
  bancosantanderLogo,
  bancochileLogo,
} from "@/assets/images";

const partners = [
  { name: "Gamelab Edication", logo: gamelabLogo },
  { name: "Colegio Medico", logo: colegioMedicoLogo },
  { name: "Talana", logo: talanaDark },
  { name: "Leanbo", logo: leanboLogo },
];

const features = [
  {
    id: 1,
    hash: "download",
    title: "Descarga tus datos de forma frecuente, simple y segura",
    subtitle:
      "Automatizamos las descargas de información tanto de páginas web como los datos de tus aplicaciones en la nube",
    logo: cloudDatabase,
    details: [
      {
        icon: "key",
        text:
          "Olvídate de tener que compartir las credenciales para descargar información, registra de manera segura tus claves en nuestro servicio y no corras riesgos",
      },
      {
        icon: "sync",
        text:
          "Cuenta con la información actualizada, sin tener que ingresar a diario a tus servicios y mantener costosos procesos de carga manuales proclives a fallar",
      },
      {
        icon: "book-reader",
        text:
          "Tu servicio requiere un RPA con credenciales o es una API y funciona con OAuth? no te preocupes, Datalized Connect se encarga de configurar la conexión de manera simple y mantener tus datos actualizados",
      },
    ],
  },
  {
    id: 2,
    hash: "centralize",
    title: "Centraliza la información de tus aplicaciones en nube",
    subtitle:
      "Centralizamos tus datos y los disponemos en una base de datos administrada por nosotros o en una que tu prefieras.",
    logo: cloudServer,
    details: [
      {
        icon: "database",
        text:
          "Carga los datos en tu propia base de datos compatible con nuestro sistema, PostgreSQL o SQL Server, o si tu organización no cuenta con base de datos habilitamos una en la nube de uso exclusivo para tu organización",
      },
      {
        icon: "table",
        text:
          "Accede a los datos de tus servicios de manera estructurada, ordenados en diferentes tablas, permitiéndote cruzar información de múltiples servicios",
      },
    ],
  },
  {
    id: 3,
    hash: "report",
    title: "Diseñado para que te enfoques en analizar tus datos",
    subtitle:
      "Puedes analizar toda tu información en Excel, PowerBI, Tableau o en la herramienta de visualización que prefieras.",
    logo: visualize,
    details: [
      {
        icon: "user-clock",
        text:
          'Dedica tu tiempo generar valor para tu empresa en vez de "pelear" con integraciones',
      },
      {
        icon: "chart-area",
        text:
          "Con tu información ya estructurada puedes conectar el software de BI de tu preferencia o simplemente desde excel para analizar tu información",
      },
    ],
  },
];

const extractors = [
  {
    id: 8,
    slug: "asana",
    name: "Asana",
    description:
      "Asana​ es una aplicación web diseñada para mejorar y optimizar la comunicación y la colaboración en equipo. Con nuestra sincronización lleva a tu datawarehouse los datos de tus proyectos, tareas y usuarios.",
    logo: asanaLogo,
    type: "PRODUCTIVIDAD",
  },
  {
    id: 14,
    slug: "bci",
    name: "Banco BCI",
    description:
      "LLeva los datos de las transacciones de tu cuenta corriente empresa del Banco BCI a tu datawarehouse, para realizar conciliaciones y cruzar con tu información financiera interna y operacional",
    logo: bancobciLogo,
    type: "FINANCIERO",
  },
  {
    id: 12,
    slug: "banco_chile",
    name: "Banco de Chile",
    description:
      "LLeva los datos de las transacciones de tu cuenta corriente empresa del Banco de Chile a tu datawarehouse, para realizar conciliaciones y cruzar con tu información financiera interna y operacional",
    logo: bancochileLogo,
    type: "FINANCIERO",
  },
  {
    id: 15,
    slug: "banco_estado",
    name: "Banco Estado",
    description:
      "LLeva los datos de las transacciones de tu cuenta corriente empresa del Banco Estado a tu datawarehouse, para realizar conciliaciones y cruzar con tu información financiera interna y operacional",
    logo: bancoestadoLogo,
    type: "FINANCIERO",
  },
  {
    id: 16,
    slug: "banco_itau",
    name: "Banco Itaú",
    description:
      "LLeva los datos de las transacciones de tu cuenta corriente empresa del Banco Itau a tu datawarehouse, para realizar conciliaciones y cruzar con tu información financiera interna y operacional",
    logo: bancoitauLogo,
    type: "FINANCIERO",
  },
  {
    id: 7,
    slug: "bsale",
    name: "BSALE",
    description:
      "Bsale es un software de venta con boleta electrónica pensado para las Pymes, el extractor te permite obtener información de ventas y otros documentos utilizando la API de BSale",
    logo: bsaleLogo,
    type: "FINANCIERO",
  },
  {
    id: 1,
    slug: "buk",
    name: "Buk",
    description:
      "La integración de BUK te permite obtener las principales relaciones en BUK, como empleados, ausencias y vacaciones\nPara utilizar esta integración debes conocer la url de tu instalación de BUK y la API Key",
    tables: [
      "empleados",
      "ausencias",
      "vacaciones",
      "accounting",
      "contrataciones",
      "desvinculaciones",
      "detalle de payroll mensual",
      "horas extras",
    ],
    logo: bukLogo,
    type: "RRHH",
  },
  {
    id: 11,
    slug: "facebook_ads",
    name: "FacebookAds",
    description:
      "La integración de Facebook Ads te permite obtener desde tu cuenta los datos de campañas y avisos utilizando la API de Facebook Marketing",
    logo: facebookadsLogo,
    type: "MARKETING",
  },
  {
    id: 10,
    slug: "google_ads",
    name: "GoogleAds",
    description:
      "La integración de Google Ads te permite obtener desde tu cuenta los datos de campañas y avisos",
    logo: gadsLogo,
    type: "MARKETING",
  },
  {
    id: 6,
    slug: "hubspot",
    name: "Hubspot",
    description:
      "Hubspot ofrece diversas herramientas como CRM, Email Marketing y CMS, utilizando la integración extrae la información de los deals, contactos y empresas desde el CRM u otros elementos a traves de la completa API de Hubspot",
    logo: hubspotLogo,
    type: "CRM",
  },
  {
    id: 4,
    slug: "pipedrive",
    name: "Pipedrive",
    description:
      "La integración de Pipedrive permite mediante una API Key obtener todas las entidades registradas en Pipedrive, como los deals, personas, etapas, actividades, notas y productos.",
    logo: pipedriveLogo,
    type: "CRM",
  },
  {
    id: 13,
    slug: "santander",
    name: "Santander",
    description:
      "LLeva los datos de las transacciones de tu cuenta corriente empresa del Banco Santander a tu datawarehouse, para realizar conciliaciones y cruzar con tu información financiera interna y operacional",
    logo: bancosantanderLogo,
    type: "FINANCIERO",
  },
  {
    id: 2,
    slug: "sii",
    name: "Servicio de Impuestos",
    description:
      "La integración del servicio de impuestos internos te permite obtener el registro de compras y ventas asociados a tu Rut, utilizando tu usuario y contraseña de manera automatizada.",
    logo: siiLogo,
    type: "FINANCIERO",
  },
  {
    id: 3,
    slug: "talana",
    name: "Talana",
    description:
      "La integración de Talana permite obtener las principales entidades en este sistema como personas, contratos, vacaciones y ausencias, para utilizarla debes poseer una API Key.",
    logo: talanaLogo,
    type: "RRHH",
  },
  {
    id: 5,
    slug: "transbank",
    name: "Transbank",
    description:
      "La integración de Transbank permite conectarse a este servicio y descargar información de manera estructurada, actualmente de las liquidaciones de abono disponibles.",
    logo: transbankLogo,
    type: "FINANCIERO",
  },
  {
    id: 9,
    slug: "trello",
    name: "Trello",
    description:
      "Trello es un software de administración de proyectos, a traves de este extractor obtiene la información de proyectos y tareas",
    logo: trelloLogo,
    type: "PRODUCTIVIDAD",
  },
];

const tagList = [
  { name: "TODOS", isSelected: true },
  { name: "CRM", isSelected: false },
  { name: "FINANCIERO", isSelected: false },
  { name: "MARKETING", isSelected: false },
  { name: "PRODUCTIVIDAD", isSelected: false },
  { name: "RRHH", isSelected: false },
];

const visualizers = [
  { id: 1, name: "Excel", logo: excelLogo },
  { id: 2, name: "Tableau", logo: tableauLogo },
  { id: 3, name: "Power BI", logo: powerBILogo },
];

export { partners, features, extractors, visualizers, tagList };
